import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/dribbble': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8c136.7 0 248 111.3 248 248s-111.3 248-248 248-248-111.3-248-248 111.3-248 248-248zM420 122.4c-4.5 6-40 51.5-118.3 83.5 7.4 15.2 12.9 27.6 18.6 41.6 70.5-8.9 140.5 5.3 147.5 6.8-0.5-50-18.3-95.9-47.8-132zM396.4 97.9c-52.1-46.2-122.9-63.7-190.1-47.5 5.9 7.8 44.3 60.2 79 124 75.3-28.2 107.2-71.1 111-76.5zM165.9 64.6c-59.3 28-103.6 82.6-117.3 148.3 9.5 0.1 96.7 0.5 195.8-25.8-35.1-62.4-73-114.8-78.5-122.5zM44.2 256.3c0 54.4 20.6 104.1 54.5 141.6 34.3-58.8 103.9-120.7 180.5-142.3-5.3-12-11.1-24.1-17.2-35.9-105.8 31.7-208.4 30.3-217.7 30.1-0.1 2.2-0.1 4.3-0.1 6.5zM126 423.4c62.8 48.9 144.7 56.9 212.8 27.9-3.2-18.6-15.4-83.4-45.2-160.6-85.4 29.1-145.5 87.5-167.6 132.8zM374.4 431.9c47.5-32.1 81.4-83 90.8-142-7.2-2.3-65.6-19.7-131.9-9.1 27.7 76.1 39 138.1 41.2 151z'
      }
    ]
  }
})
